import { render, staticRenderFns } from "./AdminDefault.vue?vue&type=template&id=5a0aa284&scoped=true&"
import script from "./AdminDefault.vue?vue&type=script&lang=js&"
export * from "./AdminDefault.vue?vue&type=script&lang=js&"
import style0 from "./AdminDefault.vue?vue&type=style&index=0&id=5a0aa284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0aa284",
  null
  
)

export default component.exports